/**
 * Modern React Context API for passing configuration down the component tree.
 *
 * @module Display.Common.Context.ConfigContext
 */

import React from 'react';

/**
 * Context for passing display configuration (assetUrl, assetUgcUrl, etc.) to child components.
 *
 * @type {React.Context}
 */
const ConfigContext = React.createContext({
  assetUrl:    '',
  assetUgcUrl: '',
});

ConfigContext.displayName = 'ConfigContext';

export default ConfigContext;
